import React from 'react';
import { useTranslation } from 'react-i18next';

import { Iata } from 'types/Search/airport';

import {
    getAirportChipList,
    getAirportLabel,
    getCountryLabel,
} from '../../__helper/airport';
import { Country } from '../../types';
import styles from '../Airport.module.scss';

interface ChipListProps {
    entryList: Set<Iata>;
    onChipClick: (code?: Iata, country?: Country) => void;
    onDeleteClick: () => void;
}

const Chip = ({ entryList, onChipClick, onDeleteClick }: ChipListProps) => {
    const { t } = useTranslation();
    return (
        <div className={styles.ChipList}>
            {getAirportChipList(entryList).map((element) => (
                <span
                    className={styles.Chip}
                    key={element.code ?? element.country}
                    onClick={() => onChipClick(element.code, element.country)}
                >
                    {element.code
                        ? t(getAirportLabel(element.code))
                        : `${getCountryLabel(t, element.country)} - ${t(
                              'TRANS-all-airports'
                          )}`}
                </span>
            ))}
            <span className={styles.Delete} onClick={() => onDeleteClick()}>
                {t('TRANS-delete-all')}
            </span>
        </div>
    );
};

export default Chip;
